import React, { useState, useRef, useCallback, useEffect } from "react";
import * as Tone from "tone";
import CodeMirror from "@uiw/react-codemirror";
import { javascript } from "@codemirror/lang-javascript";
import { oneDark } from "@codemirror/theme-one-dark";
import Header from "./Header";
import { auth } from "./firebase";
import { onAuthStateChanged } from "firebase/auth";
import { saveTrackToDB, updateTrackInDB } from './database';
import { useLocation } from "react-router-dom";






// 🎨 STYLES: CSS Stil tanımları
// highlightStyle kısmını bununla değiştir:
const highlightStyle = document.createElement("style");
highlightStyle.innerHTML = `
  @keyframes flashAnimation {
    0% { background-color: rgba(60, 255, 60, 0.4); border-left-color: #0f0; }
    100% { background-color: transparent; border-left-color: transparent; }
  }

  .active-line {
    /* Animasyonu tanımla: 150ms sürsün, bitince dursun */
    animation: flashAnimation 0.15s ease-out forwards;
    
    /* Performans için tarayıcıya ipucu ver */
    will-change: background-color, border-left-color;
    
    border-left: 4px solid transparent; /* Varsayılan gizli */
    position: relative; /* Render sırasını garantile */
    z-index: 1;
  }
    /* 🎵 BEAT REACTIVE BORDER - RASTGELE RENKLER */
.main-panel {
  transition: border-color 0.1s ease-out, box-shadow 0.1s ease-out;
}

@keyframes colorPulse1 {
  0% { 
    border-color: rgba(0, 216, 255, 0);
    box-shadow: 0 0 0px rgba(0, 216, 255, 0);
  }
  50% { 
    border-color: rgba(0, 216, 255, 0.8);
    box-shadow: 0 0 8px rgba(0, 216, 255, 0.3);
  }
  100% { 
    border-color: rgba(0, 216, 255, 0);
    box-shadow: 0 0 0px rgba(0, 216, 255, 0);
  }
}

@keyframes colorPulse2 {
  0% { 
    border-color: rgba(255, 50, 0, 0);
    box-shadow: 0 0 0px rgba(255, 50, 0, 0);
  }
  50% { 
    border-color: rgba(255, 50, 0, 0.8);
    box-shadow: 0 0 8px rgba(255, 50, 0, 0.3);
  }
  100% { 
    border-color: rgba(255, 50, 0, 0);
    box-shadow: 0 0 0px rgba(255, 50, 0, 0);
  }
}

@keyframes colorPulse3 {
  0% { 
    border-color: rgba(0, 255, 100, 0);
    box-shadow: 0 0 0px rgba(0, 255, 100, 0);
  }
  50% { 
    border-color: rgba(0, 255, 100, 0.8);
    box-shadow: 0 0 8px rgba(0, 255, 100, 0.3);
  }
  100% { 
    border-color: rgba(0, 255, 100, 0);
    box-shadow: 0 0 0px rgba(0, 255, 100, 0);
  }
}

.main-panel.color-1 {
  animation: colorPulse1 0.3s ease-out;
}

.main-panel.color-2 {
  animation: colorPulse2 0.3s ease-out;
}

.main-panel.color-3 {
  animation: colorPulse3 0.3s ease-out;
}
  
  canvas {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    pointer-events: none;
    opacity: 0.8;
  }
  
  .ui-container {
    position: relative;
    z-index: 10;
  }

  /* 🎨 CUSTOM SCROLLBAR - CodeMirror & Dashboard */

/* CodeMirror Scrollbar (Sol editör) */
.cm-scroller::-webkit-scrollbar {
  width: 10px;
}

.cm-scroller::-webkit-scrollbar-track {
  background: #1e1e1e;
  border-left: 1px solid #111;
}

.cm-scroller::-webkit-scrollbar-thumb {
  background: #333;
  border-radius: 0;
  border-left: 2px solid #1e1e1e;
}

.cm-scroller::-webkit-scrollbar-thumb:hover {
  background: #00d8ff;
}

.cm-scroller::-webkit-scrollbar-corner {
  background: transparent;
  /* veya */
  background: #1e1e1e; /* Editörün arka plan rengiyle aynı */
}


/* Dashboard Scrollbar (Sağ panel - eğer overflow olursa) */
.dashboard-panel::-webkit-scrollbar {
  width: 8px;
}

.dashboard-panel::-webkit-scrollbar-track {
  background: #050505;
}

.dashboard-panel::-webkit-scrollbar-thumb {
  background: #1a1a1a;
  border-radius: 4px;
}

.dashboard-panel::-webkit-scrollbar-thumb:hover {
  background: #222;
}

.modern-btn {
  flex: 1;
  background: linear-gradient(180deg, #1a1a1a 0%, #0f0f0f 100%);
  border: 1px solid #333;
  border-bottom: 2px solid #000; /* Alt kenarda kalınlık */
  color: #777;
  padding: 10px 14px;
  font-family: 'Consolas', 'Courier New', monospace;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 1px;
  border-radius: 0; /* TAM DİKDÖRTGEN */
  cursor: pointer;
  transition: all 0.1s ease;
  text-transform: uppercase;
  text-shadow: 0 1px 2px rgba(0,0,0,0.5);
}

.modern-btn:hover {
  border-color: #444;
  color: #aaa;
  background: linear-gradient(180deg, #222 0%, #111 100%);
}

.modern-btn.active {
  background: linear-gradient(180deg, #0a0a0a 0%, #000 100%);
  border-color: #61afef;
  border-top: 1px solid #61afef;
  border-bottom: 2px solid #61afef;
  color: #61afef;
  box-shadow: inset 0 0 20px rgba(97, 175, 239, 0.2),
              0 0 10px rgba(97, 175, 239, 0.3);
  text-shadow: 0 0 8px rgba(97, 175, 239, 0.5);
}

/* BRUTAL INDUSTRIAL TASARIM */
.control-btn {
  height: 50px;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 1.5px;
  background: #0a0a0a;
  border: 2px solid #1a1a1a;
  border-radius: 0; /* Tam dikdörtgen - hiç yuvarlak yok */
  cursor: pointer;
  transition: all 0.1s ease;
  text-transform: uppercase;
  font-family: 'Consolas', monospace;
  box-shadow: inset 0 0 0 1px #000,
              2px 2px 0 #000;
}

.play-btn {
  color: #0f0;
  border-top-color: #0f0;
}

.play-btn:not(:disabled):hover {
  background: #0f0;
  color: #000;
  border-color: #0f0;
  box-shadow: inset 0 0 0 1px #0f0,
              3px 3px 0 #000;
}

.play-btn:not(:disabled):active {
  transform: translate(2px, 2px);
  box-shadow: inset 0 0 0 1px #0f0;
}

.stop-btn:not(:disabled) {
  color: #f00;
  border-top-color: #f00;
}

.stop-btn:not(:disabled):hover {
  background: #f00;
  color: #000;
  border-color: #f00;
  box-shadow: inset 0 0 0 1px #f00,
              3px 3px 0 #000;
}

.stop-btn:not(:disabled):active {
  transform: translate(2px, 2px);
  box-shadow: inset 0 0 0 1px #f00;
}

.control-btn:disabled {
  color: #333;
  border-color: #1a1a1a;
  box-shadow: inset 0 0 0 1px #000;
}

/* 🎚️ MICRO-STRIP SLIDER STYLES (En İnce Versiyon) */
.compact-slider-container {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 6px;       /* Üst/Alt padding SIFIRLANDI */
  height: 18px;         /* Toplam yükseklik sadece 18px */
  border: 1px solid #1a1a1a; /* Kenarlık rengi koyulaştırıldı */
  border-radius: 2px;   /* Daha keskin köşeler */
  background: #080808;  /* Daha koyu zemin */
  margin-bottom: 0;     /* Dış boşluk sıfır */
}

.compact-slider-container:hover {
  background: #111;
  border-color: #333;
}

.slider-label {
  font-size: 8px;       /* Font iyice küçüldü */
  color: #555;
  font-weight: 800;
  min-width: 20px;
  line-height: 18px;    /* Dikey ortalama için */
}

.slider-value {
  font-size: 9px;
  font-weight: bold;
  min-width: 22px;
  text-align: right;
  font-family: 'Consolas', monospace;
  line-height: 18px;
}

.slider-value.bpm { color: #00d8ff; }
.slider-value.vol { color: #0f0; }

input[type="range"] {
  flex: 1;
  height: 2px;          /* Çizgi kalınlığı */
  appearance: none;
  background: #222;     /* Pasif kısım rengi */
  border-radius: 0;
  outline: none;
  cursor: pointer;
}

/* --- CHROME / SAFARI / EDGE --- */
input[type="range"]::-webkit-slider-thumb {
  appearance: none;
  width: 4px;           /* TOP YERİNE İNCE ÇUBUK */
  height: 10px;         /* Çubuğun boyu */
  background: #fff;
  border-radius: 1px;   /* Hafif yumuşak köşe */
  cursor: ew-resize;    /* İmleç sağ-sol ok olur */
  box-shadow: 0 0 4px rgba(255, 255, 255, 0.4);
  transition: background 0.2s, height 0.2s;
  margin-top: 0; 
}

/* Hover durumunda çubuk parlasın ve hafif büyüsün */
input[type="range"]:hover::-webkit-slider-thumb {
  background: #fff;
  height: 12px;         /* Üzerine gelince hafif uzasın */
  box-shadow: 0 0 8px rgba(255, 255, 255, 0.8);
}

/* --- FIREFOX --- */
input[type="range"]::-moz-range-thumb {
  width: 4px;
  height: 10px;
  border: none;
  background: #fff;
  border-radius: 1px;
  cursor: ew-resize;
}


`;
document.head.appendChild(highlightStyle);

function StudioPage() {
  const [user, setUser] = useState(null);
   // Save & Publish States
  const [showSaveModal, setShowSaveModal] = useState(false);
  const [trackTitle, setTrackTitle] = useState("");
  const [saveMode, setSaveMode] = useState("save"); // "save" or "publish"
  const [isSaving, setIsSaving] = useState(false);
  const [currentTrackId, setCurrentTrackId] = useState(null);
  const [isPublished, setIsPublished] = useState(false);
  const [savedTrackTitle, setSavedTrackTitle] = useState(""); 
  const [sliderBPM, setSliderBPM] = useState(140);
  const [sliderVolume, setSliderVolume] = useState(80);

  



  // 📝 DEFAULT CODE (Swing ve Master Volume Eklendi)
  const [code, setCode] = useState(`// GLOBAL SETTINGS

bpm = 140
swing = 0         
master_volume = 80  


// Start your composition below this line

{
   kick(c1)

}

`);

  const [log, setLog] = useState("");
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentBlock, setCurrentBlock] = useState("");
  
  const [isLoaded, setIsLoaded] = useState(false); // Varsayılan: Yüklenmedi
  const [visualizerEnabled, setVisualizerEnabled] = useState(true);
  const [glowEnabled, setGlowEnabled] = useState(true);
const [elapsedTime, setElapsedTime] = useState(0); // Saniye sayacı
const timerRef = useRef(null); // Zamanlayıcıyı durdurmak için referans
const [displayStats, setDisplayStats] = useState({
    bpm: 140,
    vol: 80,
    swing: 0,
    blocks: 0
});
const location = useLocation();
  
  
  // 🔗 REFS
  const editorRef = useRef(null);
  const canvasRef = useRef(null);
  const analyser = useRef(null);
  const animationRef = useRef(null);
  const lineTimeouts = useRef(new Map());
  const lastFlashTime = useRef(new Map());
  const particles = useRef([]);
  const mainPanelRef = useRef(null);
  const lastBeatTime = useRef({ kick: 0, snare: 0, hihat: 0 });
  const glowRef = useRef(true);      // <-- YENİ
const visualizerRef = useRef(true); // <-- YENİ

  const instruments = useRef(null);
  
  // 🎛️ GLOBAL MASTER FX
  const masterReverb = useRef(null);
  const masterDelay = useRef(null);
  const masterChorus = useRef(null);
  
  const activeEffects = useRef([]);
  const allParts = useRef([]);

  const handleBPMSlider = (newBPM) => {
  setSliderBPM(newBPM);
  
  // Kod içinde BPM satırını bul ve değiştir
  const bpmRegex = /^bpm\s*=\s*\d+/m;
  if (bpmRegex.test(code)) {
    setCode(code.replace(bpmRegex, `bpm = ${newBPM}`));
  }
};

const handleVolumeSlider = (newVol) => {
  setSliderVolume(newVol);
  
  // Kod içinde volume satırını bul ve değiştir
  const volRegex = /^master_volume\s*=\s*\d+/m;
  if (volRegex.test(code)) {
    setCode(code.replace(volRegex, `master_volume = ${newVol}`));
  }
};
  // --- 3. STATE -> REF KÖPRÜSÜ (Bunu eklemezsen butonlar çalışmaz) ---
  useEffect(() => {
    glowRef.current = glowEnabled;
    visualizerRef.current = visualizerEnabled;
    // Konsola yazdıralım ki çalıştığını görelim
    console.log("Durum Güncellendi -> Glow:", glowEnabled, "Visuals:", visualizerEnabled);
  }, [glowEnabled, visualizerEnabled]);

  // Kod değiştiğinde slider'ları senkronize et
useEffect(() => {
  const bpmMatch = code.match(/^bpm\s*=\s*(\d+)/m);
  const volMatch = code.match(/^master_volume\s*=\s*(\d+)/m);
  
  if (bpmMatch) setSliderBPM(parseInt(bpmMatch[1]));
  if (volMatch) setSliderVolume(parseInt(volMatch[1]));
}, [code]);

  useEffect(() => {
    
  const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
    console.log("🔐 Auth state changed:", currentUser ? currentUser.email : "No user");
    setUser(currentUser);
  });
  return () => unsubscribe();
  }, []);

  useEffect(() => {
  // Profil'den gelen track verisi var mı kontrol et
  if (location.state?.loadedCode) {
    console.log("🎵 Track loaded from Profile");
    
    setCode(location.state.loadedCode);
    
    if (location.state.loadedTitle) {
      setSavedTrackTitle(location.state.loadedTitle);
    }
    
    if (location.state.loadedTrackId) {
      setCurrentTrackId(location.state.loadedTrackId);
    }
    
    if (location.state.isPublic !== undefined) {
      setIsPublished(location.state.isPublic);
    }
    
    setLog(`✅ Track "${location.state.loadedTitle || 'Untitled'}" loaded from your profile!`);
    
    // State'i temizle (Geri dönünce tekrar yüklenmesin)
    window.history.replaceState({}, document.title);
  }
  const loadedFromExplorer = localStorage.getItem('loadedTrackFromExplorer');
  if (loadedFromExplorer) {
    try {
      const trackData = JSON.parse(loadedFromExplorer);
      console.log("🌍 Track loaded from Explorer");
      
      setCode(trackData.code);
      setSavedTrackTitle(trackData.title);
      setCurrentTrackId(trackData.trackId);
      setIsPublished(true); // Explorer'dan gelenler her zaman public
      
      setLog(`✅ Track "${trackData.title}" by @${trackData.ownerUsername} loaded from Explorer!`);
      
      // localStorage'ı temizle
      localStorage.removeItem('loadedTrackFromExplorer');
    } catch (error) {
      console.error("❌ Explorer track loading error:", error);
    }
  }
  }, [location]);

  // ⚙️ SETUP & LOOP (UseEffect)
  useEffect(() => {
    // 1. ANALYSER KURULUMU
    analyser.current = new Tone.Analyser("fft", 128);
    analyser.current.toDestination();

    // 2. MASTER FX KURULUMU (Analyser'a bağlanır)
    masterReverb.current = new Tone.Reverb({
       decay: 2.5,
       preDelay: 0.01 
    }).connect(analyser.current);
    masterReverb.current.generate();
    
    masterDelay.current = new Tone.FeedbackDelay("8n", 0.4).connect(analyser.current);
    masterChorus.current = new Tone.Chorus(4, 2.5, 0.5).connect(analyser.current).start();
    const loadOneShot = (fileName, folder) => {
    // 1. Sampler'ı oluştur
    const sampler = new Tone.Sampler({
        urls: { "C1": fileName }, 
        baseUrl: folder,
        volume: 0 
    }).toDestination().connect(analyser.current);

    // 2. O uzun "Wrapper" kodunu burası halletsin
    return {
        connect: (dest) => { sampler.connect(dest); return this; },
        disconnect: () => { sampler.disconnect(); },
        dispose: () => { sampler.dispose(); },
        
        // Hangi notayı basarsan bas, C1 çalsın:
        triggerAttackRelease: (note, duration, time, velocity) => {
            sampler.triggerAttackRelease("C1", duration, time, velocity);
        }
    };
};
    // 3. ENSTRÜMAN KURULUMU (Analyser'a bağlanır)
    instruments.current = {
      kick: new Tone.PolySynth(Tone.MembraneSynth, { volume: -8 }).connect(analyser.current),
      snare: new Tone.NoiseSynth({ 
          envelope: { attack: 0.005, decay: 0.1, sustain: 0 },
          volume: -2 
      }).connect(analyser.current),
      hihat: new Tone.MetalSynth({ 
          frequency: 200, 
          envelope: { attack: 0.001, decay: 0.1, release: 0.01 }, 
          harmonicity: 5.1, modulationIndex: 32, 
          resonance: 4000, octaves: 1.5,
          volume: -12 
      }).connect(analyser.current),
      bass: new Tone.PolySynth(Tone.FMSynth, { 
          harmonicity: 1, modulationIndex: 3.5, 
          oscillator: { type: "custom", partials: [0, 1, 0, 2] }, 
          envelope: { attack: 0.08, decay: 0.3, sustain: 0, release: 0.2 }, 
          modulation: { type: "square" }, 
          modulationEnvelope: { attack: 0.1, decay: 0.2, sustain: 0.3, release: 0.01 },
          volume: -5
      }).connect(analyser.current),
      synth: new Tone.PolySynth(Tone.AMSynth, { volume: -5 }).connect(analyser.current),
      saw: new Tone.PolySynth(Tone.Synth, {
      oscillator: { type: "sawtooth" },
      envelope: { attack: 0.005, decay: 0.1, sustain: 0.3, release: 1 },
      volume: -10
       }).connect(analyser.current),

  // 2. SINE (Sinüs - Yumuşak ve Derin)
        sine: new Tone.PolySynth(Tone.Synth, {
            oscillator: { type: "sine" },
            envelope: { attack: 0.01, decay: 0.1, sustain: 0.5, release: 1.2 },
            volume: -8
        }).connect(analyser.current),

  // 3. SQUARE (Kare - Retro ve Atari Sesi)
        square: new Tone.PolySynth(Tone.Synth, {
            oscillator: { type: "square" },
            envelope: { attack: 0.01, decay: 0.2, sustain: 0.2, release: 1 },
            volume: -12 // Kare dalga genelde daha gürültülüdür, sesi biraz kıstık
        }).connect(analyser.current),

        // 5. LEAD (Analog Moog tarzı, kayan sesler için MonoSynth)
        // Not: PolySynth yerine doğrudan MonoSynth kullanıyoruz ki notalar birbirine kayabilsin (portamento)
        lead: new Tone.MonoSynth({
            oscillator: { type: "square" },
            envelope: { attack: 0.1, decay: 0.3, sustain: 0.4, release: 2 },
            filterEnvelope: { attack: 0.06, decay: 0.2, sustain: 0.5, release: 2, baseFrequency: 200, octaves: 3, exponent: 2 },
            volume: -10
        }).connect(analyser.current),

        // 6. NOISE (Rüzgar, okyanus veya fx efektleri için)
        noise: new Tone.NoiseSynth({
            noise: { type: 'pink' }, // 'white', 'pink', 'brown' olabilir
            envelope: { attack: 0.5, decay: 0.1, sustain: 0, release: 0.5 },
            volume: -15
        }).connect(analyser.current),
        electric_bass: new Tone.Sampler({
    // Sol taraf: Tone.js Notası (Diyez # ile yazılır)
    // Sağ taraf: Senin Dosya Adın (s harfi ile yazılır)
    urls: {
        "A#1": "As1.wav",
        "A#2": "As2.wav",
        "A#3": "As3.wav",
        "A#4": "As4.wav",
        
        "C#1": "Cs1.wav",
        "C#2": "Cs2.wav",
        "C#3": "Cs3.wav",
        "C#4": "Cs4.wav",
        "C#5": "Cs5.wav",

        "E1": "E1.wav",
        "E2": "E2.wav",
        "E3": "E3.wav",
        "E4": "E4.wav",
        "G1": "G1.wav",
        "G2": "G2.wav",
        "G3": "G3.wav",
        "G4": "G4.wav",

        // Not: Tüm notaları tek tek yazmana gerek yok!
        // Tone.js aradaki eksik notaları (örn: D1) kendisi tamamlar.
    },
    release: 1,
    // Dosyalarının olduğu klasör yolu (public klasöründen itibaren):
    baseUrl: "/instruments1/electric_bass/"
}).toDestination().connect(analyser.current),
// 🎸 ACOUSTIC GUITAR
acoustic_guitar: new Tone.Sampler({
    urls: {
        // A (La) Notaları
        "A2": "A2.wav",
        "A3": "A3.wav",
        "A4": "A4.wav",
        "A#2": "As2.wav", // Resimdeki As2.wav -> Kodda A#2
        "A#3": "As3.wav",
        "A#4": "As4.wav",

        // B (Si) Notaları
        "B2": "B2.wav",
        "B3": "B3.wav",
        "B4": "B4.wav",

        // C (Do) Notaları
        "C3": "C3.wav",
        "C4": "C4.wav",
        "C5": "C5.wav",
        "C#3": "Cs3.wav",
        "C#4": "Cs4.wav",
        "C#5": "Cs5.wav",
        "D2": "D2.wav",
        "D3": "D3.wav",
        "D4": "D4.wav",
        "D5": "D5.wav",
        "D#2": "Ds2.wav",
        "D#3": "Ds3.wav",
        "D#4": "Ds4.wav",
        "E2": "E2.wav",
        "E3": "E3.wav",
        "E4": "E4.wav",
        "F2": "F2.wav",
        "F3": "F3.wav",
        "F4": "F4.wav",
        "F#2": "Fs2.wav",
        "F#3": "Fs3.wav",
        "F#4": "Fs4.wav",
        "G2": "G2.wav",
        "G3": "G3.wav",
        "G4": "G4.wav",
        "G#2": "Gs2.wav",
        "G#3": "Gs3.wav",
        "G#4": "Gs4.wav",
        
    },
    release: 1,
    
    baseUrl: "/instruments1/acoustic_guitar/"
}).toDestination().connect(analyser.current),

// 🎹 GRAND PIANO (1-7 Oktav)
piano: new Tone.Sampler({
    urls: {
        // 1. OKTAV
        "C1": "C1.wav",
        "D1": "D1.wav",
        "E1": "E1.wav",
        "F1": "F1.wav",
        "G1": "G1.wav",
        "A1": "A1.wav",
        "B1": "B1.wav",

        // 2. OKTAV
        "C2": "C2.wav",
        "D2": "D2.wav",
        "E2": "E2.wav",
        "F2": "F2.wav",
        "G2": "G2.wav",
        "A2": "A2.wav",
        "B2": "B2.wav",

        // 3. OKTAV
        "C3": "C3.wav",
        "D3": "D3.wav",
        "E3": "E3.wav",
        "F3": "F3.wav",
        "G3": "G3.wav",
        "A3": "A3.wav",
        "B3": "B3.wav",

        // 4. OKTAV (Orta C Buradadır)
        "C4": "C4.wav",
        "D4": "D4.wav",
        "E4": "E4.wav",
        "F4": "F4.wav",
        "G4": "G4.wav",
        "A4": "A4.wav",
        "B4": "B4.wav",

        // 5. OKTAV
        "C5": "C5.wav",
        "D5": "D5.wav",
        "E5": "E5.wav",
        "F5": "F5.wav",
        "G5": "G5.wav",
        "A5": "A5.wav",
        "B5": "B5.wav",

        // 6. OKTAV
        "C6": "C6.wav",
        "D6": "D6.wav",
        "E6": "E6.wav",
        "F6": "F6.wav",
        "G6": "G6.wav",
        "A6": "A6.wav",
        "B6": "B6.wav",

        // 7. OKTAV
        "C7": "C7.wav",
        "D7": "D7.wav",
        "E7": "E7.wav",
        "F7": "F7.wav",
        "G7": "G7.wav",
        "A7": "A7.wav",
        "B7": "B7.wav",
    },
    release: 1,
    // ⚠️ KLASÖR YOLU: Dosyaların yerini kendine göre teyit et
    baseUrl: "/instruments1/piano/"
}).toDestination().connect(analyser.current),


      kick1: loadOneShot("kick1.wav", "/samples/kick_samples/"),
      kick2: loadOneShot("kick2.wav", "/samples/kick_samples/"),
      kick3: loadOneShot("kick3.wav", "/samples/kick_samples/"),
      kick4: loadOneShot("kick4.wav", "/samples/kick_samples/"),
      kick5: loadOneShot("kick5.wav", "/samples/kick_samples/"),
      kick6: loadOneShot("kick6.wav", "/samples/kick_samples/"),
      snare1: loadOneShot("snare1.wav", "/samples/snare_samples/"),
      snare2: loadOneShot("snare2.wav", "/samples/snare_samples/"),
      snare3: loadOneShot("snare3.wav", "/samples/snare_samples/"),
      snare4: loadOneShot("snare4.wav", "/samples/snare_samples/"),
      snare5: loadOneShot("snare5.wav", "/samples/snare_samples/"),
      snare6: loadOneShot("snare6.wav", "/samples/snare_samples/"),
      snare7: loadOneShot("snare7.wav", "/samples/snare_samples/"),
      clap1: loadOneShot("clap1.wav", "/samples/clap_samples/"),
      clap2: loadOneShot("clap2.wav", "/samples/clap_samples/"),
      clap3: loadOneShot("clap3.wav", "/samples/clap_samples/"),
      clap4: loadOneShot("clap4.wav", "/samples/clap_samples/"),
      clap5: loadOneShot("clap5.wav", "/samples/clap_samples/"),
      clap6: loadOneShot("clap6.wav", "/samples/clap_samples/"),
      clap7: loadOneShot("clap7.wav", "/samples/clap_samples/"),
      closed_hat1: loadOneShot("closedhat1.wav", "/samples/closedhat_samples/"),
      closed_hat2: loadOneShot("closedhat2.wav", "/samples/closedhat_samples/"),
      closed_hat3: loadOneShot("closedhat3.wav", "/samples/closedhat_samples/"),
      closed_hat4: loadOneShot("closedhat4.wav", "/samples/closedhat_samples/"),
      closed_hat5: loadOneShot("closedhat5.wav", "/samples/closedhat_samples/"),
      closed_hat6: loadOneShot("closedhat6.wav", "/samples/closedhat_samples/"),
      closed_hat7: loadOneShot("closedhat7.wav", "/samples/closedhat_samples/"),
      808_1: loadOneShot("808_1.wav", "/samples/808_samples/"),
      808_2: loadOneShot("808_2.wav", "/samples/808_samples/"),
      808_3: loadOneShot("808_3.wav", "/samples/808_samples/"),
      808_4: loadOneShot("808_4.wav", "/samples/808_samples/"),
      808_5: loadOneShot("808_5.wav", "/samples/808_samples/"),
      808_6: loadOneShot("808_6.wav", "/samples/808_samples/"),
      808_7: loadOneShot("808_7.wav", "/samples/808_samples/"),
      808_8: loadOneShot("808_8.wav", "/samples/808_samples/"),
      808_9: loadOneShot("808_9.wav", "/samples/808_samples/"),
      808_10: loadOneShot("808_10.wav", "/samples/808_samples/"),
      perc_1: loadOneShot("perc1.wav", "/samples/perc_samples/"),
      perc_2: loadOneShot("perc2.wav", "/samples/perc_samples/"),
      perc_3: loadOneShot("perc3.wav", "/samples/perc_samples/"),
      perc_4: loadOneShot("perc4.wav", "/samples/perc_samples/"),
      perc_5: loadOneShot("perc5.wav", "/samples/perc_samples/"),
      perc_6: loadOneShot("perc6.wav", "/samples/perc_samples/"),
      perc_7: loadOneShot("perc7.wav", "/samples/perc_samples/"),
      perc_8: loadOneShot("perc8.wav", "/samples/perc_samples/"),
      perc_9: loadOneShot("perc9.wav", "/samples/perc_samples/"),
      open_hat1: loadOneShot("openhat1.wav", "/samples/openhat_samples/"),
      open_hat2: loadOneShot("openhat2.wav", "/samples/openhat_samples/"),
      open_hat3: loadOneShot("openhat3.wav", "/samples/openhat_samples/"),
      open_hat4: loadOneShot("openhat4.wav", "/samples/openhat_samples/"),
      open_hat5: loadOneShot("openhat5.wav", "/samples/openhat_samples/"),




// 🥁 DAVUL SETİ (Daha gerçekçi davullar için)

      default: new Tone.PolySynth(Tone.Synth, { volume: -10 }).connect(analyser.current)
    };

    Tone.loaded().then(() => {
        setIsLoaded(true);
        setLog("> System Ready. All samples loaded.");
    });

    // 4. GÖRSELLEŞTİRME LOOP (Render Frame)
    // 4. GÖRSELLEŞTİRME LOOP (Render Frame)
    const renderFrame = () => {
      const canvas = canvasRef.current;
      if (!canvas) return;
      const ctx = canvas.getContext("2d");
      const w = canvas.width;
      const h = canvas.height;

      // Ekranı temizle
      ctx.clearRect(0, 0, w, h);

      if (analyser.current) {
        const values = analyser.current.getValue();

        // --- GLOW KONTROLÜ ---
        if (glowRef.current === true) { 
             const now = Date.now();
             
             // 1. BASS (Kick) - İlk 10 frekans
             const bassE = values.slice(0, 10).reduce((s, v) => s + (v === -Infinity ? 0 : Tone.dbToGain(v)), 0) / 10;
             
             // 2. MID (Snare/Vokal) - 10 ile 100 arası (kabaca)
             const midE = values.slice(10, 100).reduce((s, v) => s + (v === -Infinity ? 0 : Tone.dbToGain(v)), 0) / 90;
             
             // 3. TREBLE (Hi-hat) - 100 ile 400 arası
             // Tiz seslerin enerjisi düşük olduğu için * 3 veya * 4 ile çarparak boostluyoruz.
             const trebleE = (values.slice(100, 400).reduce((s, v) => s + (v === -Infinity ? 0 : Tone.dbToGain(v)), 0) / 300) * 4;

             // Toplam vuruş gücü (Hepsinden biraz alıyoruz)
             const totalHit = bassE + midE + trebleE;
             
             // Eşik değerini (0.05) biraz düşürüp totalHit'i kontrol ediyoruz
             // Böylece hem snare hem hihat hem de kick geldiğinde tetiklenir.
             if (totalHit > 0.04 && (now - lastBeatTime.current.kick) > 120) {
                 if (mainPanelRef.current) {
                     // Animasyonu sıfırlamak için trick
                     mainPanelRef.current.classList.remove('color-1', 'color-2', 'color-3');
                     void mainPanelRef.current.offsetWidth; 
                     
                     const rnd = Math.floor(Math.random() * 3) + 1;
                     mainPanelRef.current.classList.add('color-' + rnd);
                     lastBeatTime.current.kick = now;
                 }
             }
        }

        // --- VISUALIZER KONTROLÜ ---
       if (visualizerRef.current === true) {
    const visibleBars = 48;
    const barWidth = w / visibleBars;

    for (let i = 0; i < visibleBars; i++) {
        // SENİN MANTIĞIN + ÇOK KÜÇÜK BİR GENİŞLETME
        // i yerine i * 1.2 diyoruz. 
        // 0-48 arasını değil, 0-60 arasını tarıyoruz. 
        // Böylece ekran doluluğu bozulmaz ama biraz daha 'mid' sesleri yakalarız.
        let index = Math.floor(i * 1.2); 

        // Hata vermesin diye koruma
        if (index >= values.length) index = values.length - 1;

        let db = values[index]; // Senin kodundaki mantık
        if (db === -Infinity || db < -100) db = -100;
        
        let amp = Tone.dbToGain(db);

        // --- BOOST KISMI ---
        let dh = amp * 10; // Senin standart yüksekliğin

        // Basları koru (İlk 8 çubuk)
        if (i < 8) {
            dh *= 1.5; 
        }
        // Mid ve Tizleri güçlendir (8'den sonrası)
        else {
            // Senin kodunda burası yoktu, ekledik.
            // i arttıkça (sağa gittikçe) boyu ekstra büyütüyoruz.
            // (i / 12) formülüyle sağa gittikçe 1.5x, 2x, 3x katına çıkarıyor.
            dh *= (1 + (i / 12)); 
        }

        const finalH = Math.min(h, dh * h * 0.8);

        // --- ÇİZİM (Senin renkler) ---
        ctx.fillStyle = "rgba(0, 255, 0, 0.4)";
        ctx.fillRect(i * barWidth, h - finalH, barWidth - 2, finalH);
        
        ctx.fillStyle = "rgba(0, 255, 0, 0.1)";
        ctx.fillRect(i * barWidth, 0, barWidth - 2, finalH * 0.6);
    }
}
      }
      animationRef.current = requestAnimationFrame(renderFrame);
    };

    // --- RENDER'I BAŞLAT ---
    renderFrame();

    // Canvas Resize Handler
    const handleResize = () => {
        if(canvasRef.current) {
            canvasRef.current.width = window.innerWidth;
            canvasRef.current.height = window.innerHeight;
        }
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    

    // CLEANUP
    return () => {
      
      window.removeEventListener("resize", handleResize);
      cancelAnimationFrame(animationRef.current);
      lineTimeouts.current.forEach(timeoutId => clearTimeout(timeoutId));
      lineTimeouts.current.clear();
      if (instruments.current) {
        Object.values(instruments.current).forEach(inst => inst.dispose());
      }
      masterReverb.current?.dispose();
      masterDelay.current?.dispose();
      masterChorus.current?.dispose();
      analyser.current?.dispose();
    };
  }, []);

  const onCreateEditor = useCallback((view) => {
    editorRef.current = view;
  }, []);

  // 🧩 PARSING HELPERS
  // 🧩 GÜNCELLENMİŞ PARSE NOTES (Öklid Destekli)
const parseNotes = (notesString) => {
    const result = [];
    let buffer = "";
    let inBracket = false;
    let parenDepth = 0; // Parantez takibi için (virgülleri karıştırmamak adına)

    const processToken = (token) => {
        let t = token.trim();
        if (!t) return null;

        // 1. Durak (Rest) Kontrolü
        if (t.startsWith("|")) return ["-", t.substring(1)];
        else if (t.endsWith("|")) return [t.slice(0, -1), "-"];
        else if (t === "-") return "-"; // Doğrudan tire ise

        // 2. Öklid Kontrolü: Örnek: "C4(3,8)"
        // Regex: Bir nota/isim, sonra parantez içinde sayı,virgül,sayı
        const euclidMatch = t.match(/^([a-zA-Z0-9#]+)\s*\(\s*(\d+)\s*,\s*(\d+)\s*\)$/);
        
        if (euclidMatch) {
            const noteName = euclidMatch[1];       // "C4" veya "kick"
            const hits = parseInt(euclidMatch[2]); // 3
            const steps = parseInt(euclidMatch[3]);// 8
            
            const pattern = getEuclideanPattern(hits, steps);
            
            // 1 olan yere notayı, 0 olan yere "-" (es) koyuyoruz
            return pattern.map(bit => bit === 1 ? noteName : "-");
        }

        // 3. Mevcut Çarpma Mantığı (C4*4)
        const asteriskPos = t.indexOf("*");
        if (asteriskPos !== -1 && !t.includes("(") ) { // Parantez yoksa
            const beforeAsterisk = t.substring(0, asteriskPos);
            const afterAsterisk = t.substring(asteriskPos + 1);

            if (Number.isInteger(parseFloat(afterAsterisk))) {
                const note = beforeAsterisk.trim();
                const count = parseInt(afterAsterisk) || 1;
                if (count > 1) {
                    return Array(count).fill(note);
                }
                return note;
            }
        }
        return t;
    };

    // --- Token Ayıklama Döngüsü ---
    for (let i = 0; i < notesString.length; i++) {
        const char = notesString[i];
        
        if (char === "[") { inBracket = true; buffer = ""; }
        else if (char === "]") {
            inBracket = false;
            const subNotesRaw = buffer.split(","); // Köşeli parantez içi virgülle ayrılır
            const subNotesProcessed = subNotesRaw.map(n => {
                const processed = processToken(n);
                return processed || n.trim();
            });
            result.push(subNotesProcessed);
            buffer = "";
        }
        else if (char === "(") { parenDepth++; buffer += char; }
        else if (char === ")") { parenDepth--; buffer += char; }
        else if (char === "," && !inBracket && parenDepth === 0) {
            // Sadece ana seviyedeki virgüllerde böl (Parantez içindeki virgüle dokunma)
            const processed = processToken(buffer);
            if (processed) result.push(processed);
            buffer = "";
        }
        else {
            buffer += char;
        }
    }
    const finalToken = processToken(buffer);
    if (finalToken) result.push(finalToken);
    
    // Flatten (İç içe dizileri düzeltmek gerekebilir ama senin yapın buna uygun şimdilik)
    return result;
};

  // 🔄 1. YENİ ÖZELLİK: Kod Ön İşleyici (Değişkenleri Bulur ve Yerine Koyar)
// 🛠️ 1. KOD ÖN İŞLEYİCİ (Değişkenleri bulur ve yerine koyar)
const preprocessCode = (rawCode) => {
    let cleanCode = rawCode;
    const variables = {};
    // #değişken = değerler
    const varRegex = /^#([a-zA-Z0-9_]+)\s*=\s*\(?([^)\n]+)\)?/gm;
    let match;
    while ((match = varRegex.exec(cleanCode)) !== null) {
        variables[match[1].trim()] = match[2].trim();
    }
    cleanCode = cleanCode.replace(varRegex, "");
    Object.keys(variables).forEach(varName => {
        const replaceRegex = new RegExp(`#${varName}\\b`, "g");
        cleanCode = cleanCode.replace(replaceRegex, variables[varName]);
    });
    return cleanCode;
};

// 🛠️ 2. NOTA AYRIŞTIRICI (Süre : ve Olasılık % Desteği)
const parseNoteDetails = (rawString) => {
      if (typeof rawString !== "string") return { notes: [rawString], velocity: 1, durationMult: 1, probability: 1 };
      
      let str = rawString;
      let velocity = 1;
      let durationMult = 1; 
      let probability = 1; // Varsayılan %100

      // A) Olasılık Kontrolü (%50 -> 0.5)
      if (str.includes("%")) {
          const parts = str.split("%");
          str = parts[0]; 
          const probVal = parseFloat(parts[1]); 
          if (!isNaN(probVal)) {
              probability = probVal / 100;
          }
      }

      // B) Uzunluk Kontrolü (:2 -> 2 kat süre)
      if (str.includes(":")) {
          const parts = str.split(":");
          str = parts[0]; 
          const lenVal = parseFloat(parts[1]);
          if (!isNaN(lenVal)) durationMult = lenVal;
      }

      // C) Velocity (Parantezli)
      const parenMatch = str.match(/^(.+?)\(([0-9.]+)\)$/);
      if (parenMatch) {
          str = parenMatch[1];
          const velValue = parseFloat(parenMatch[2]);
          velocity = velValue > 1 ? velValue / 100 : velValue;
      }
      
      // D) Velocity (Çarpılı - Eski destek)
      if (str.includes("*")) {
          const parts = str.split("*");
          const potentialVel = parseFloat(parts[1]);
          if (!Number.isInteger(potentialVel) && potentialVel <= 1) {
              str = parts[0];
              velocity = potentialVel;
          }
      }
      
      const rawNotes = str.split(/\+(?=[A-G])/);
      return { notes: rawNotes, velocity, durationMult, probability };
};

  const parseEffectArgs = (argsStr) => {
    if (!argsStr) return [];
    return argsStr.split(",").map(s => {
        const trimmed = s.trim();
        return isNaN(parseFloat(trimmed)) ? trimmed : parseFloat(trimmed);
    });
  };

  const createEffect = (fxName, argsStr) => {
      try {
        const args = parseEffectArgs(argsStr);
        let effectNode = null;

        switch (fxName.toLowerCase()) {
            case "volume":
            case "vol":
                const volVal = args[0] !== undefined ? args[0] : 100;
                return new Tone.Gain(Math.max(0, volVal) / 100);

            case "pan":
            case "panner":
                const panVal = args[0] !== undefined ? args[0] : 0;
                return new Tone.Panner(panVal);

            case "eq":
            case "eq3":
                const low = args[0] !== undefined ? args[0] : 0;
                const mid = args[1] !== undefined ? args[1] : 0;
                const high = args[2] !== undefined ? args[2] : 0;
                return new Tone.EQ3(low, mid, high);

            case "reverb":
                const reverbWet = args[0] !== undefined ? args[0] : 1;
                const reverbSend = new Tone.Gain(reverbWet);
                reverbSend.connect(masterReverb.current);
                return reverbSend;

            case "delay":
            case "feedbackdelay":
                const delayWet = args[2] !== undefined ? args[2] : 1;
                const delaySend = new Tone.Gain(delayWet);
                delaySend.connect(masterDelay.current);
                return delaySend;
                
            case "chorus":
                const chorusWet = args[3] !== undefined ? args[3] : 1;
                const chorusSend = new Tone.Gain(chorusWet);
                chorusSend.connect(masterChorus.current);
                return chorusSend;

            case "distortion":
                effectNode = new Tone.Distortion(args[0] || 0.4);
                if (args[1] !== undefined) effectNode.wet.value = args[1];
                else effectNode.wet.value = 1;
                return effectNode;

            case "bitcrusher":
                effectNode = new Tone.BitCrusher(args[0] || 4);
                if (args[1] !== undefined) effectNode.wet.value = args[1];
                else effectNode.wet.value = 1;
                return effectNode;

            case "phaser":
                effectNode = new Tone.Phaser({
                    frequency: args[0] || 0.5,
                    octaves: args[1] || 3,
                    baseFrequency: args[2] || 350
                });
                if (args[3] !== undefined) effectNode.wet.value = args[3];
                else effectNode.wet.value = 1;
                return effectNode;

            case "tremolo":
                effectNode = new Tone.Tremolo(args[0]||9, args[1]||0.75).start();
                if (args[2] !== undefined) effectNode.wet.value = args[2];
                else effectNode.wet.value = 1;
                return effectNode;
                
            case "autofilter":
                effectNode = new Tone.AutoFilter(args[0]||1).start();
                if (args[1] !== undefined) effectNode.wet.value = args[1];
                else effectNode.wet.value = 1;
                return effectNode;

            case "gain":
                const gainVal = args[0] !== undefined ? args[0] : 1;
                return new Tone.Gain(gainVal);
                case "lpf": // Low Pass Filter (Sesi boğuklaştırır)
            case "lowpass":
                // args[0]: Frekans (örn: 1000), args[1]: Q (Resonance)
                effectNode = new Tone.Filter(args[0] || 1000, "lowpass");
                if (args[1]) effectNode.Q.value = args[1]; // Resonance ekle
                return effectNode;

            case "hpf": // High Pass Filter (Basları tıraşlar, cızırtı bırakır)
            case "highpass":
                effectNode = new Tone.Filter(args[0] || 500, "highpass");
                return effectNode;

            case "widener": // Stereo Genişletici (Sesi sağa sola yayar)
            case "stereo":
                return new Tone.StereoWidener(args[0] || 0.7);

            default:
                return null;
        }
      } catch (e) {
          console.error("Efekt hatası:", e);
          return null;
      }
  };

const flashLine = (lineIndex, time) => {
  Tone.Draw.schedule(() => {
    if (!editorRef.current || !editorRef.current.contentDOM) return;
    
    // CodeMirror içindeki satırları bul
    const lines = editorRef.current.contentDOM.querySelectorAll(".cm-line");
    const lineElement = lines[lineIndex];
    
    if (lineElement) {
      // 1. Önce sınıfı KALDIR (Eğer zaten yanıyorsa söndür)
      lineElement.classList.remove("active-line");

      // 2. Bir sonraki frame'de sınıfı EKLE (Animasyonu tetikle)
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
           lineElement.classList.add("active-line");
        });
      });
    }
  }, time);
};

  const parseBlocks = (codeString) => {
    const blocks = [];
    const lines = codeString.split("\n");
    let currentBlock = null;
    
    lines.forEach((line, index) => {
      const trimmed = line.trim();
      if (trimmed === "{") {
        currentBlock = {
          lines: [],
          loopCount: 1,
          startLine: index,
          endLine: -1
        };
      }
      else if (trimmed.startsWith("}")) {
        if (currentBlock) {
          currentBlock.endLine = index;
          const loopMatch = trimmed.match(/\}\s*\*\s*(\d+)/);
          if (loopMatch) {
            currentBlock.loopCount = parseInt(loopMatch[1]);
          }
          blocks.push(currentBlock);
          currentBlock = null;
        }
      }
      else if (currentBlock && trimmed && !trimmed.startsWith("//")) {
        currentBlock.lines.push({
          content: trimmed,
          lineIndex: index
        });
      }
    });
    return blocks;
  };

  // 🧮 EUCLIDEAN RHYTHM GENERATOR
// k: vuruş sayısı, n: toplam adım sayısı
const getEuclideanPattern = (k, n) => {
    let pattern = [];
    let bucket = 0;
    for (let i = 0; i < n; i++) {
        bucket += k;
        if (bucket >= n) {
            bucket -= n;
            pattern.push(1); // Vuruş var
        } else {
            pattern.push(0); // Es (Sessizlik)
        }
    }
    // Ters çevirmek bazen müzikal olarak daha 'on beat' hissettirir, 
    // ama şimdilik düz kalsın. İsteğe bağlı .reverse() eklenebilir.
    return pattern;
};

  // 🌍 GLOBAL AYARLARI OKUYAN PARSER (GÜNCELLENDİ: Swing & Volume)
  const parseGlobalSettings = (codeString) => {
    const settings = { 
        bpm: 120,
        swing: 0,
        master_volume: 100 // Default 100 (Full Gain)
    };
    const lines = codeString.split("\n");
    
    lines.forEach(line => {
        const trimmed = line.trim();
        
        // BPM
        const bpmMatch = trimmed.match(/^bpm\s*=\s*(\d+)/i);
        if (bpmMatch) settings.bpm = parseInt(bpmMatch[1]);

        // SWING
        const swingMatch = trimmed.match(/^swing\s*=\s*([0-9.]+)/i);
        if (swingMatch) settings.swing = parseFloat(swingMatch[1]);

        // MASTER VOLUME
        const volMatch = trimmed.match(/^(master_)?volume\s*=\s*(\d+)/i);
        if (volMatch) settings.master_volume = parseInt(volMatch[2]);
    });
    return settings;
  };
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60).toString().padStart(2, '0');
    const secs = (seconds % 60).toString().padStart(2, '0');
    return `${mins}:${secs}`;
  };

  // ▶️ PLAY LOGIC
 const runCode = async () => {
    try {
        // -------------------------------------------------------------------------
        // 1. ÖN HAZIRLIK (Pre-processing)
        // -------------------------------------------------------------------------
        const processedCode = preprocessCode(code);

        // -------------------------------------------------------------------------
        // 2. GLOBAL AYARLAR
        // -------------------------------------------------------------------------
        const bpmMatch = processedCode.match(/bpm\s*=\s*(\d+)/);
        const volMatch = processedCode.match(/master_volume\s*=\s*(\d+)/);
        const swingMatch = processedCode.match(/swing\s*=\s*([0-9.]+)/);
        const blockCount = parseBlocks(processedCode);

        setDisplayStats({
            bpm: bpmMatch ? parseInt(bpmMatch[1]) : 120,
            vol: volMatch ? parseInt(volMatch[1]) : 80,
            swing: swingMatch ? parseFloat(swingMatch[1]) : 0.2,
            blocks: blockCount.length
        });

        setElapsedTime(0);
        if (timerRef.current) clearInterval(timerRef.current);
        timerRef.current = setInterval(() => {
            setElapsedTime(prev => prev + 1);
        }, 1000);

        // -------------------------------------------------------------------------
        // 3. SES MOTORU BAŞLATMA
        // -------------------------------------------------------------------------
        if (Tone.context.state !== "running") await Tone.context.resume();
        await Tone.start();

        Tone.Transport.stop();
        Tone.Transport.cancel(0);
        
        allParts.current.forEach(part => part.dispose());
        allParts.current = [];
        
        activeEffects.current.forEach(fx => fx.dispose());
        activeEffects.current = [];

        Object.values(instruments.current).forEach(inst => {
            inst.disconnect();
            inst.connect(analyser.current);
        });

        const settings = parseGlobalSettings(processedCode);
        Tone.Transport.bpm.value = settings.bpm;
        Tone.Transport.swing = settings.swing; 
        Tone.Transport.swingSubdivision = "16n";
        
        const volRatio = Math.max(0, settings.master_volume) / 100;
        const dbVal = (volRatio === 0) ? -Infinity : 20 * Math.log10(volRatio);
        Tone.Destination.volume.rampTo(dbVal, 0.1);

        // -------------------------------------------------------------------------
        // 4. BLOK PARSE VE GÜVENLİK
        // -------------------------------------------------------------------------
        const blocks = parseBlocks(processedCode);
        
        if (blocks.length === 0) {
            if (processedCode.trim().length > 0 && !processedCode.includes("{")) {
                 throw new Error("Hata: Kod blokları { } içinde olmalıdır.");
            }
            return;
        }

        let currentBarPosition = 0;
        
        blocks.forEach((block, blockIdx) => {
          const blockStartTime = currentBarPosition * Tone.Time("1m").toSeconds();
          
          Tone.Transport.schedule((time) => {
            setCurrentBlock(`Blok ${blockIdx + 1}/${blocks.length} (${block.loopCount}x)`);
          }, blockStartTime);
          
          const blockEffects = [];
          const allBlockEvents = [];
          
          // Satır okuma döngüsü
          block.lines.forEach(({ content, lineIndex }, lineArrayIndex) => {
            if (!content.trim()) return;

            const firstParenIndex = content.indexOf("(");
            if (firstParenIndex === -1) return;
            
            const instrumentName = content.substring(0, firstParenIndex).trim().toLowerCase();
            
            // GÜVENLİK KONTROLÜ
            if (!instruments.current.hasOwnProperty(instrumentName)) {
                 throw new Error(`Satır ${lineIndex + 1}: "${instrumentName}" adında bir enstrüman bulunamadı.`);
            }

            const rest = content.substring(firstParenIndex);
            
            let openCount = 0;
            let closeIndex = -1;
            for(let i=0; i<rest.length; i++) {
                if(rest[i] === "(") openCount++;
                if(rest[i] === ")") openCount--;
                if(openCount === 0) {
                    closeIndex = i;
                    break;
                }
            }
            
            if (closeIndex === -1) throw new Error(`Satır ${lineIndex + 1}: Parantez hatası.`);

            const notesRaw = rest.substring(1, closeIndex);
            const chainString = rest.substring(closeIndex + 1);
            
            const notes = parseNotes(notesRaw);
            const baseSynth = instruments.current[instrumentName];
            
            // ---------------------------------------------------------------------
            // EFEKT ZİNCİRİ (Uzun ve detaylı haliyle)
            // ---------------------------------------------------------------------
            let finalNode = analyser.current; 
            const insertChain = []; 
            const sendEffects = []; 
            
            if (chainString && chainString.includes(".")) {
                 const effectsRaw = [];
                let currentEffect = "";
                let parenDepth = 0;
                for (let i = 0; i < chainString.length; i++) {
                    const char = chainString[i];
                    if (char === "(") parenDepth++;
                    else if (char === ")") parenDepth--;
                    else if (char === "." && parenDepth === 0) {
                        if (currentEffect.trim()) effectsRaw.push(currentEffect.trim());
                        currentEffect = "";
                        continue;
                    }
                    currentEffect += char;
                }
                if (currentEffect.trim()) effectsRaw.push(currentEffect.trim());
                
                effectsRaw.forEach((fxStr) => {
                    const trimmed = fxStr.trim();
                    const openParen = trimmed.indexOf("(");
                    let fxName, fxArgs;
                    if (openParen === -1) { fxName = trimmed; fxArgs = ""; } 
                    else { 
                        fxName = trimmed.substring(0, openParen); 
                        const closeParen = trimmed.lastIndexOf(")"); 
                        fxArgs = trimmed.substring(openParen + 1, closeParen); 
                    }
                    
                    const effectNode = createEffect(fxName, fxArgs);
                    if (effectNode) {
                        activeEffects.current.push(effectNode);
                        if (['reverb', 'delay', 'feedbackdelay', 'chorus'].includes(fxName.toLowerCase())) {
                            sendEffects.push(effectNode);
                        } else {
                            insertChain.push(effectNode);
                        }
                        blockEffects.push(effectNode);
                    }
                });
                
                if (insertChain.length > 0) {
                    for (let i = 0; i < insertChain.length - 1; i++) {
                        insertChain[i].connect(insertChain[i + 1]);
                    }
                    insertChain[insertChain.length - 1].connect(analyser.current);
                    finalNode = insertChain[0];
                    sendEffects.forEach(sendNode => insertChain[insertChain.length - 1].connect(sendNode));
                } else {
                    finalNode = analyser.current; 
                    if(sendEffects.length > 0) finalNode = { type: 'parallel_sends', sends: sendEffects };
                }
            }

            // ---------------------------------------------------------------------
            // SCHEDULING (Zamanlama Hesapları)
            // ---------------------------------------------------------------------
            const barLength = Tone.Time("1m").toSeconds();
            const stepLength = Tone.Time("4n").toSeconds();
            
            for (let loopIdx = 0; loopIdx < block.loopCount; loopIdx++) {
              notes.forEach((rawStep, stepIdx) => {
                const barOffset = currentBarPosition + loopIdx;
                const stepSeconds = stepIdx * stepLength;
                const absoluteTime = (barOffset * barLength) + stepSeconds;
                
                allBlockEvents.push({
                  time: absoluteTime,
                  note: rawStep,
                  lineIndex: lineIndex,
                  synth: baseSynth,
                  instrumentName: instrumentName,
                  outputNode: finalNode
                });
              });
            }
          });
          
          const blockEndTime = (currentBarPosition + block.loopCount) * Tone.Time("1m").toSeconds();
          Tone.Transport.schedule(() => {
            blockEffects.forEach(fx => {
              try { fx.disconnect(); fx.dispose(); } catch(e) {}
            });
          }, blockEndTime);
          
          // -----------------------------------------------------------------------
          // 6. PART OLUŞTURMA (BURASI ARTIK EN UZUN VE DETAYLI HALİNDE)
          // -----------------------------------------------------------------------
          if (allBlockEvents.length > 0) {
            allBlockEvents.sort((a, b) => a.time - b.time);
            
            const blockPart = new Tone.Part((time, event) => {
              const rawStep = event.note;
              flashLine(event.lineIndex, time);
              
              if (rawStep !== "-") {
                  
                  // Routing
                  try { event.synth.disconnect(); } catch(e) {}
                  
                  if (event.outputNode && event.outputNode.type === 'parallel_sends') {
                      event.synth.connect(analyser.current); 
                      event.outputNode.sends.forEach(sendNode => event.synth.connect(sendNode));
                  } else {
                      event.synth.connect(event.outputNode);
                  }
                  
                  // ===============================================================
                  // MİKRO NOTALAR [[a,b]]
                  // ===============================================================
                  if (Array.isArray(rawStep)) {
                      const subDuration = Tone.Time("4n").toSeconds() / rawStep.length;
                      
                      rawStep.forEach((subNoteRaw, i) => {
                          // A.1 EN DERİN SEVİYE
                          if (Array.isArray(subNoteRaw)) {
                              const microDuration = subDuration / 2;
                              subNoteRaw.forEach((microNote, k) => {
                                  if (microNote !== "-") {
                                      // PARSE & PROBABILITY
                                      const { notes, velocity, durationMult, probability } = parseNoteDetails(microNote);
                                      if (Math.random() >= probability) return; // Şans

                                      const triggerTime = time + (i * subDuration) + (k * microDuration);
                                      
                                      notes.forEach(n => {
                                          // 1. ÖZEL SÜRE VAR MI?
                                          if(durationMult && durationMult !== 1) {
                                              const dur = Tone.Time("32n").toSeconds() * durationMult;
                                              // SNARE CHECK
                                              if (event.instrumentName === "snare" || event.instrumentName === "noise") {
                                                  event.synth.triggerAttackRelease(dur, triggerTime, velocity);
                                              } else {
                                                  event.synth.triggerAttackRelease(n, dur, triggerTime, velocity);
                                              }
                                          } 
                                          // 2. NORMAL SÜRE
                                          else {
                                              // SNARE CHECK
                                              if (event.instrumentName === "snare" || event.instrumentName === "noise") {
                                                  event.synth.triggerAttackRelease("32n", triggerTime, velocity);
                                              } else {
                                                  event.synth.triggerAttackRelease(n, microDuration, triggerTime, velocity);
                                              }
                                          }
                                      });
                                  }
                              });

                          // A.2 ORTA SEVİYE [a,b]
                          } else if(subNoteRaw !== "-") {
                              // PARSE & PROBABILITY
                              const { notes, velocity, durationMult, probability } = parseNoteDetails(subNoteRaw); 
                              if (Math.random() >= probability) return; // Şans

                              const triggerTime = time + (i * subDuration);
                              
                              notes.forEach(n => {
                                  // 1. ÖZEL SÜRE VAR MI?
                                  if(durationMult && durationMult !== 1) {
                                      const base = event.instrumentName === "snare" ? Tone.Time("16n").toSeconds() : subDuration;
                                      const dur = base * durationMult;
                                      
                                      // SNARE CHECK
                                      if (event.instrumentName === "snare" || event.instrumentName === "noise") {
                                          event.synth.triggerAttackRelease(dur, triggerTime, velocity);
                                      } else {
                                          event.synth.triggerAttackRelease(n, dur, triggerTime, velocity);
                                      }
                                  } 
                                  // 2. NORMAL SÜRE
                                  else {
                                      // SNARE CHECK
                                      if (event.instrumentName === "snare" || event.instrumentName === "noise") {
                                          event.synth.triggerAttackRelease("16n", triggerTime, velocity);
                                      } else {
                                          event.synth.triggerAttackRelease(n, subDuration, triggerTime, velocity);
                                      }
                                  }
                              });
                          }
                      });

                  // ===============================================================
                  // STANDART NOTALAR (C4)
                  // ===============================================================
                  } else {
                      // PARSE & PROBABILITY
                      const { notes, velocity, durationMult, probability } = parseNoteDetails(rawStep);
                      if (Math.random() >= probability) return; // Şans

                      notes.forEach(n => {
                          // 1. ÖZEL SÜRE VAR MI?
                          if(durationMult && durationMult !== 1) {
                              const dur = Tone.Time("8n").toSeconds() * durationMult;
                              
                              // SNARE CHECK
                              if (event.instrumentName === "snare" || event.instrumentName === "noise") {
                                  event.synth.triggerAttackRelease(dur, time, velocity);
                              } else {
                                  event.synth.triggerAttackRelease(n, dur, time, velocity);
                              }
                          } 
                          // 2. NORMAL SÜRE
                          else {
                              // SNARE CHECK
                              if (event.instrumentName === "snare" || event.instrumentName === "noise") {
                                  event.synth.triggerAttackRelease("8n", time, velocity);
                              } else {
                                  event.synth.triggerAttackRelease(n, "8n", time, velocity);
                              }
                          }
                      });
                  }
              }
            }, allBlockEvents).start(0);
            
            allParts.current.push(blockPart);
          }
          currentBarPosition += block.loopCount;
        });
        
        // -------------------------------------------------------------------------
        // 7. BİTİŞ VE TEMİZLİK
        // -------------------------------------------------------------------------
        const totalBars = currentBarPosition;
        const endTime = totalBars * Tone.Time("1m").toSeconds();
        Tone.Transport.schedule(() => {
          stopMusic();
          setLog("✅ Playback finished.");
        }, endTime);

        Tone.Transport.start("+0.1");
        setIsPlaying(true);
        setLog(`✅ BPM: ${settings.bpm} | Blocks: ${blocks.length} | Vars: ${Object.keys(preprocessCode(code).match(/#\w+/g) || {}).length}`);

    } catch (error) {
      setLog("⛔ ERROR: " + error.message);
      console.error(error);
      stopMusic();
    }
  };

  const stopMusic = () => {
    Tone.Transport.stop();
    Tone.Transport.cancel(); 
    setIsPlaying(false);
    setCurrentBlock(null);
    if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
    }
    setElapsedTime(0);
    allParts.current.forEach(part => part.dispose());
    allParts.current = [];  
    
    if(instruments.current) {
        Object.values(instruments.current).forEach(synth => {
             if(synth.releaseAll) synth.releaseAll();
        });
    }
    
    if (activeEffects.current && activeEffects.current.length > 0) {
        activeEffects.current.forEach(fx => {
            try {
                fx.disconnect(); // Önce bağlantıyı kes
                fx.dispose();    // Sonra bellekten sil
            } catch (e) {
                console.warn("Clean up error:", e);
            }
        });
        // Listeyi boşalt
        activeEffects.current = [];
    }
    
    setIsPlaying(false);
    setCurrentBlock("");
    setLog("Stopped.");
  };

  const handleSave = () => {
    if (!user) {
      setLog("❌ Please login to save tracks!");
      return;
    }

    if (isPublished) {
    setLog("⛔ Published tracks cannot be modified!");
    return;
  }
    setSaveMode("save");


    if (currentTrackId &&savedTrackTitle) {
        confirmSaveWithoutModal();
    } else {
        setShowSaveModal(true); // İlk kayıtta modal göster
    }
  };


  const confirmSaveWithoutModal = async () => {
  setIsSaving(true);
  try {
    const success = await updateTrackInDB(currentTrackId, code, savedTrackTitle, false);
    if (success) {
      setLog(`✅ Track "${savedTrackTitle}" updated!`);
    } else {
      setLog("❌ Error updating track!");
    }
  } catch (error) {
    setLog("❌ Error: " + error.message);
    console.error("Save error:", error);
  } finally {
    setIsSaving(false);
  }
};

   const handlePublish = async () => {
    if (!user) {
      setLog("❌ Please login to publish tracks!");
      return;
    }

    if (isPublished) {
    setLog("⛔ This track is already published and cannot be modified!");
    return;
  }
    if (currentTrackId && savedTrackTitle) {
      setIsSaving(true);
      try {
        const success = await updateTrackInDB(currentTrackId, code, savedTrackTitle, true);
        if (success) {
          setLog(`✅ Track "${savedTrackTitle}" published successfully!`);
          setIsPublished(true);
        } else {
          setLog("❌ Error publishing track!");
        }
      } catch (error) {
        setLog("❌ Error: " + error.message);
        console.error("Publish error:", error);
      } finally {
        setIsSaving(false);
      }
    } else {
      // Yeni şarkıysa modal aç
      setSaveMode("publish");
      setShowSaveModal(true);
    }
  };


  const confirmSave = async () => {
    const finalTitle = savedTrackTitle || trackTitle;
    if (!trackTitle.trim()) {
      setLog("❌ Please enter a track title!");
      return;
    }
    setIsSaving(true);
    try {
      const isPublic = saveMode === "publish";
      
      if (currentTrackId) {
        // Update existing track
        const success = await updateTrackInDB(currentTrackId, code, finalTitle, false);
        if (success) {
          setLog(`✅ Track "${finalTitle}" updated successfully!`);
          setShowSaveModal(false);
        } else {
          setLog("❌ Error updating track!");
        }
      } else {
        // Save new track
        const result = await saveTrackToDB(user.uid, finalTitle, code, isPublic);
        if (result.success) {
          setLog(`✅ Track "${finalTitle}" saved as ${isPublic ? 'PUBLIC' : 'PRIVATE'}!`);
          setShowSaveModal(false);

          setCurrentTrackId(result.trackId);
          setSavedTrackTitle(finalTitle);

          if (isPublic) {
          setIsPublished(true);
        }
        setTrackTitle("");
        } else {
          setLog("❌ Error saving track!");
        }
      }
    } catch (error) {
      if (error.message === "DUPLICATE_TITLE") {
        setLog("❌ You already have a track with this name!");
      } else {
        setLog("❌ Error: " + error.message);
      }
      console.error("Save error:", error);
    } finally {
      setIsSaving(false);
    }
  };

return (
  <>
  <Header user={user} sticky={false}></Header>
    <div style={{ 
        backgroundColor: "#050505", 
        color: "#0f0", 
        minHeight: "100vh", 
        fontFamily: "'Segoe UI', Consolas, monospace", 
        display: "flex", 
        alignItems: "center", 
        justifyContent: "center", 
        position: "relative",
        overflow: "hidden" 
    }}>
      {/* Arka Plan Canvas */}
      <canvas ref={canvasRef} style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", zIndex: 0 }} />

      {/* UI CONTAINER */}
      <div className="ui-container" style={{ position: "relative", zIndex: 1, display: "flex", flexDirection: "column", gap: "10px" }}>
        
        {/* HEADER (LOGO GÜNCELLENDİ) */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0 5px", height: "50px" }}>
            
            {/* --- YENİ LOGO BAŞLANGIÇ --- */}
            <div style={{ display: "flex", alignItems: "center", gap: "12px", cursor: "pointer", userSelect: "none" }}>
                
                {/* Logo İkonu (< >) */}
                <div style={{ 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    width: "40px", 
                    height: "40px", 
                    backgroundColor: "#111", 
                    border: "1px solid #333", 
                    borderRadius: "8px",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.5)"
                }}>
                    <span style={{ color: "#fff", fontSize: "18px", fontWeight: "bold", marginRight: "2px" }}>&lt;</span>
                    <span style={{ color: "#00d8ff", fontSize: "18px", fontWeight: "bold" }}>&gt;</span>
                </div>
                
                {/* Logo Metni (SoundCode) */}
                <div style={{ display: "flex", alignItems: "baseline", fontFamily: "'Segoe UI', sans-serif" }}>
                    <span style={{ fontSize: "24px", fontWeight: "700", color: "#fff", letterSpacing: "-0.5px" }}>Sound</span>
                    <span style={{ fontSize: "24px", fontWeight: "700", color: "#00d8ff" }}>Code</span> {/* Mavi Renk */}
                </div>
            </div>
            {/* --- YENİ LOGO BİTİŞ --- */}

            <div style={{ fontSize: "12px", color: "#666", fontWeight: "bold", alignSelf: "center" }}>v1.0 ALPHA</div>
        </div>

        {/* ANA PANEL */}
        <div ref={mainPanelRef}
        className="main-panel" style={{ 
            display: "flex", 
            width: "1000px",            
            height: "620px",
            border: "0.25px solid #333", 
            backgroundColor: "#282c34", 
            borderRadius: "12px", 
            overflow: "hidden", 
            boxShadow: "0 50px 100px rgba(0,0,0,0.9)"
        }}>
          
          {/* SOL: KOD EDİTÖRÜ */}
          <div style={{ flex: 1, height: "100%", position: "relative", borderRight: "1px solid #111", overflow: "hidden", 
              minWidth: 0 }}>
              <CodeMirror
                value={code}
                height="100%" 
                theme={oneDark}
                extensions={[javascript()]}
                onChange={(value) => setCode(value)}
                onCreateEditor={onCreateEditor}
                basicSetup={{ lineNumbers: true, highlightActiveLine: false }}
                style={{ height: "100%" }}
              />
          </div>
          
          {/* SAĞ: DASHBOARD */}
          <div style={{ 
              width: "280px", 
              backgroundColor: "#050505", 
              padding: "20px", 
              display: "flex", 
              flexShrink: 0,
              flexDirection: "column",
              borderLeft: "1px solid #222"
          }}>
            
            {/* İSTATİSTİKLER */}
            <div style={{ display: "flex", flexDirection: "column", gap: "10px", flex: 1 }}>
                
                {/* BPM */}
                <div style={{ border: "1px solid #222", borderRadius: "6px", padding: "10px", backgroundColor: "#0a0a0a" }}>
                    <div style={{ fontSize: "9px", color: "#555", fontWeight: "bold", letterSpacing: "1px" }}>CURRENT BPM</div>
                    <div style={{ fontSize: "24px", color: "#fff", fontWeight: "bold" }}>{displayStats.bpm}</div>
                </div>

                {/* VOL & SWING */}
                <div style={{ display: "flex", gap: "10px" }}>
                    <div style={{ flex: 1, border: "1px solid #222", borderRadius: "6px", padding: "10px", backgroundColor: "#0a0a0a" }}>
                        <div style={{ fontSize: "9px", color: "#555", fontWeight: "bold" }}>VOL</div>
                        <div style={{ fontSize: "16px", color: "#0f0", fontWeight: "bold" }}>{displayStats.vol}</div>
                    </div>
                    <div style={{ flex: 1, border: "1px solid #222", borderRadius: "6px", padding: "10px", backgroundColor: "#0a0a0a" }}>
                        <div style={{ fontSize: "9px", color: "#555", fontWeight: "bold" }}>SWING</div>
                        <div style={{ fontSize: "16px", color: "#fa0", fontWeight: "bold" }}>{displayStats.swing}</div>
                    </div>
                </div>

                 {/* TOTAL BLOCKS */}
                 <div style={{ border: "1px solid #222", borderRadius: "6px", padding: "10px", backgroundColor: "#0a0a0a" }}>
                    <div style={{ fontSize: "9px", color: "#555", fontWeight: "bold", letterSpacing: "1px" }}>TOTAL BLOCKS</div>
                    <div style={{ fontSize: "24px", color: "#00d8ff", fontWeight: "bold" }}>{displayStats.blocks}</div>
                </div>

                {/* ACTIVE BLOCK & TIMER */}
                <div style={{ display: "flex", gap: "10px", marginTop: "5px" }}>
                    
                    {/* Active Block (Sadece Sayı) */}
                    <div style={{ flex: 1, border: "1px solid #222", borderRadius: "6px", padding: "10px", backgroundColor: isPlaying ? "rgba(0, 255, 0, 0.05)" : "#0a0a0a", transition: "0.3s" }}>
                        <div style={{ fontSize: "9px", color: "#555", fontWeight: "bold" }}>ACTIVE BLOCK</div>
                        <div style={{ fontSize: "20px", color: isPlaying ? "#0f0" : "#333", fontWeight: "bold" }}>
                            {currentBlock ? (currentBlock.toString().match(/\d+/) || ["-"])[0] : "-"}
                        </div>
                    </div>

                    {/* Timer */}
                    <div style={{ flex: 1, border: "1px solid #222", borderRadius: "6px", padding: "10px", backgroundColor: "#0a0a0a" }}>
                         <div style={{ fontSize: "9px", color: "#555", fontWeight: "bold" }}>TIME</div>
                         <div style={{ fontSize: "20px", color: "#fff", fontWeight: "bold", fontFamily: "monospace" }}>
                            {formatTime(elapsedTime)}
                         </div>
                    </div>
                </div>

            </div> 
{/* 🎚️ COMPACT SLIDERS */}
<div style={{ display: "flex", flexDirection: "column", gap: "6px", marginBottom: "4px" , marginTop: "8px"}}>
  
  {/* BPM SLIDER */}
  <div className="compact-slider-container">
    <span className="slider-label">BPM</span>
    <input
      type="range"
      min="60"
      max="240"
      value={sliderBPM}
      onChange={(e) => handleBPMSlider(parseInt(e.target.value))}
      style={{
        background: `linear-gradient(to right, #00d8ff 0%, #00d8ff ${((sliderBPM - 60) / 180) * 100}%, #222 ${((sliderBPM - 60) / 180) * 100}%, #222 100%)`
      }}
    />
    <span className="slider-value bpm">{sliderBPM}</span>
  </div>

  {/* VOLUME SLIDER */}
  <div className="compact-slider-container">
    <span className="slider-label">VOL</span>
    <input
      type="range"
      min="0"
      max="100"
      value={sliderVolume}
      onChange={(e) => handleVolumeSlider(parseInt(e.target.value))}
      style={{
        background: `linear-gradient(to right, #0f0 0%, #0f0 ${sliderVolume}%, #222 ${sliderVolume}%, #222 100%)`
      }}
    />
    <span className="slider-value vol">{sliderVolume}</span>
  </div>

</div>

            {/* BUTONLAR */}
            <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "10px" }}>
              {/* TOGGLE BUTONLARI - Sadece className kullan */}
<div style={{ display: "flex", gap: "8px", marginTop: "auto", marginBottom: "2px" }}>
  
  {/* 1. GLOW TOGGLE */}
  <button 
    className={`modern-btn ${glowEnabled ? 'active' : ''}`}
    onClick={() => setGlowEnabled(!glowEnabled)}
  >
    GLOW: {glowEnabled ? "ON" : "OFF"}
  </button>

  {/* 2. VISUALIZER TOGGLE */}
  <button 
    className={`modern-btn ${visualizerEnabled ? 'active' : ''}`}
    onClick={() => setVisualizerEnabled(!visualizerEnabled)}
  >
    VISUALS: {visualizerEnabled ? "ON" : "OFF"}
  </button>
</div>
              <button 
              onClick={runCode} 
              style={{ marginTop: "12px" }}
              disabled={isPlaying || !isLoaded} // Yüklenmediyse tıklanamaz
              className={`control-btn play-btn`}  >
              {/* Duruma göre yazı değişir */}
              {!isLoaded ? "LOADING SAMPLES..." : (isPlaying ? "RUNNING..." : "PLAY ▶")}
            </button>
              
              <button 
                onClick={stopMusic} 
                disabled={!isPlaying}
                className={`control-btn stop-btn`}>
                STOP ■
              </button>
              
              <div style={{ marginTop: "5px", fontSize: "10px", color: "#444", textAlign: "center", fontFamily: "monospace" }}>
                {log || "> System Ready"}
              </div>
              {/* 💾 SAVE & PUBLISH ROW */}
              <div style={{ display: "flex", gap: "8px" }}>
                {/* SAVE BUTTON */}
{/* SAVE BUTTON - Yeşil Gradient */}
{/* SAVE BUTTON - Neon Yeşil */}
<button 
  onClick={handleSave}
  disabled={isPublished}
  style={{ 
    flex: 1,
    height: "40px", 
    fontSize: "14px", 
    backgroundColor: isPublished ? "#21252b" : "#0a0a0a",
    color: isPublished ? "#5c6370" : "#00ff88", // Neon yeşil
    border: `2px solid ${isPublished ? "#3e4451" : "#00ff88"}`,
    borderRadius: "8px", 
    fontWeight: "bold", 
    cursor: isPublished ? "not-allowed" : "pointer",
    opacity: isPublished ? 0.5 : 1,
    transition: "all 0.2s ease",
    boxShadow: isPublished ? "none" : "0 0 20px rgba(0, 255, 136, 0.2), inset 0 0 10px rgba(0, 255, 136, 0.1)",
    textShadow: isPublished ? "none" : "0 0 10px rgba(0, 255, 136, 0.3)"
  }}
  onMouseEnter={(e) => {
    if (!isPublished) {
        e.target.style.backgroundColor = "#00ff88";
        e.target.style.color = "#0a0a0a";
        e.target.style.boxShadow = "0 0 30px rgba(0, 255, 136, 0.3), inset 0 0 20px rgba(0, 255, 136, 0.3)";
        e.target.style.transform = "translateY(-2px)";
    }
  }}
  onMouseLeave={(e) => {
    if (!isPublished) {
        e.target.style.backgroundColor = "#0a0a0a";
        e.target.style.color = "#00ff88";
        e.target.style.boxShadow = "0 0 20px rgba(0, 255, 136, 0.2), inset 0 0 10px rgba(0, 255, 136, 0.1)";
        e.target.style.transform = "translateY(0)";
    }
  }}
>
   SAVE
</button>

{/* PUBLISH BUTTON - Neon Mor */}
<button 
  onClick={handlePublish}
  disabled={isPublished}
  style={{ 
    flex: 1, 
    height: "40px", 
    fontSize: "14px", 
    backgroundColor: isPublished ? "#21252b" : "#0a0a0a",
    color: isPublished ? "#5c6370" : "#ff00ff", // Neon pembe
    border: `2px solid ${isPublished ? "#3e4451" : "#ff00ff"}`,
    borderRadius: "8px", 
    fontWeight: "bold", 
    cursor: isPublished ? "not-allowed" : "pointer",
    opacity: isPublished ? 0.5 : 1,
    transition: "all 0.2s ease",
    boxShadow: isPublished ? "none" : "0 0 20px rgba(255, 0, 255, 0.2), inset 0 0 10px rgba(255, 0, 255, 0.1)",
    textShadow: isPublished ? "none" : "0 0 10px rgba(255, 0, 255, 0.3)"
  }}
  onMouseEnter={(e) => {
    if (!isPublished) {
        e.target.style.backgroundColor = "#ff00ff";
        e.target.style.color = "#0a0a0a";
        e.target.style.boxShadow = "0 0 30px rgba(255, 0, 255, 0.3), inset 0 0 20px rgba(255, 0, 255, 0.3)";
        e.target.style.transform = "translateY(-2px)";
    }
  }}
  onMouseLeave={(e) => {
    if (!isPublished) {
        e.target.style.backgroundColor = "#0a0a0a";
        e.target.style.color = "#ff00ff";
        e.target.style.boxShadow = "0 0 20px rgba(255, 0, 255, 0.2), inset 0 0 10px rgba(255, 0, 255, 0.1)";
        e.target.style.transform = "translateY(0)";
    }
  }}
>
   PUBLISH
</button>
              </div>

            </div>

          </div>
        </div>
      </div>
      {/* 💾 SAVE MODAL */}
{/* 💾 SAVE MODAL - NEON STYLE */}
{showSaveModal && (
  <div style={{
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.85)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2000,
    backdropFilter: "blur(8px)"
  }} onClick={() => !isSaving && setShowSaveModal(false)}>
    <div style={{
      backgroundColor: "#0a0a0a",
      border: saveMode === "publish" 
        ? "2px solid #ff00ff" 
        : "2px solid #00ff88",
      borderRadius: "16px",
      padding: "40px",
      width: "450px",
      boxShadow: saveMode === "publish"
        ? "0 0 60px rgba(255, 0, 255, 0.4), inset 0 0 20px rgba(255, 0, 255, 0.05)"
        : "0 0 60px rgba(0, 255, 136, 0.4), inset 0 0 20px rgba(0, 255, 136, 0.05)",
      position: "relative"
    }} onClick={(e) => e.stopPropagation()}>
      
      {/* Glowing Corner Accents */}
      <div style={{
        position: "absolute",
        top: "0",
        left: "0",
        width: "30px",
        height: "30px",
        borderTop: saveMode === "publish" ? "3px solid #ff00ff" : "3px solid #00ff88",
        borderLeft: saveMode === "publish" ? "3px solid #ff00ff" : "3px solid #00ff88",
        borderTopLeftRadius: "16px"
      }}></div>
      <div style={{
        position: "absolute",
        bottom: "0",
        right: "0",
        width: "30px",
        height: "30px",
        borderBottom: saveMode === "publish" ? "3px solid #ff00ff" : "3px solid #00ff88",
        borderRight: saveMode === "publish" ? "3px solid #ff00ff" : "3px solid #00ff88",
        borderBottomRightRadius: "16px"
      }}></div>

      {/* Icon */}
      <div style={{ textAlign: "center", marginBottom: "25px" }}>
        <div style={{
          fontSize: "48px",
          marginBottom: "10px",
          filter: saveMode === "publish"
            ? "drop-shadow(0 0 20px rgba(255, 0, 255, 0.8))"
            : "drop-shadow(0 0 20px rgba(0, 255, 136, 0.8))"
        }}>
          {saveMode === "publish" ? "🎵" : "💾"}
        </div>
        
        <h2 style={{
          margin: "0 0 8px 0",
          fontSize: "28px",
          color: saveMode === "publish" ? "#ff00ff" : "#00ff88",
          fontWeight: "bold",
          textShadow: saveMode === "publish"
            ? "0 0 20px rgba(255, 0, 255, 0.8)"
            : "0 0 20px rgba(0, 255, 136, 0.8)",
          letterSpacing: "2px"
        }}>
          {currentTrackId ? "UPDATE" : (saveMode === "publish" ? "PUBLISH" : "SAVE")}
        </h2>
        
        <p style={{
          margin: "0",
          fontSize: "13px",
          color: "#888",
          fontFamily: "monospace"
        }}>
          {currentTrackId 
            ? "Update your track"
            : (saveMode === "publish" 
              ? "The track will be published publicly" 
              : "The track will be saved privately")}
        </p>
      </div>

      {/* Input */}
      <div style={{ marginBottom: "25px" }}>
        <label style={{
          display: "block",
          fontSize: "10px",
          color: saveMode === "publish" ? "#ff00ff" : "#00ff88",
          marginBottom: "10px",
          fontWeight: "bold",
          letterSpacing: "2px",
          textTransform: "uppercase",
          fontFamily: "monospace"
        }}>
          {'>'} TRACK_TITLE
        </label>
        <input
          type="text"
          value={trackTitle}
          onChange={(e) => setTrackTitle(e.target.value)}
          placeholder="enter_name..."
          disabled={isSaving}
          style={{
            width: "100%",
            padding: "16px",
            backgroundColor: "#000",
            border: saveMode === "publish" 
              ? "1px solid #ff00ff" 
              : "1px solid #00ff88",
            borderRadius: "8px",
            color: "#fff",
            fontSize: "15px",
            fontFamily: "monospace",
            outline: "none",
            boxSizing: "border-box",
            boxShadow: saveMode === "publish"
              ? "0 0 20px rgba(255, 0, 255, 0.2)"
              : "0 0 20px rgba(0, 255, 136, 0.2)"
          }}
        />
      </div>

      {/* Buttons */}
      <div style={{ display: "flex", gap: "12px" }}>
        <button
          onClick={() => !isSaving && setShowSaveModal(false)}
          disabled={isSaving}
          style={{
            flex: 1,
            padding: "16px",
            fontSize: "14px",
            fontWeight: "bold",
            backgroundColor: "#0a0a0a",
            color: "#666",
            border: "2px solid #333",
            borderRadius: "8px",
            cursor: isSaving ? "not-allowed" : "pointer",
            opacity: isSaving ? 0.5 : 1,
            fontFamily: "monospace",
            letterSpacing: "1px"
          }}
          onMouseEnter={(e) => {
            if (!isSaving) {
              e.target.style.borderColor = "#666";
              e.target.style.color = "#aaa";
            }
          }}
          onMouseLeave={(e) => {
            if (!isSaving) {
              e.target.style.borderColor = "#333";
              e.target.style.color = "#666";
            }
          }}
        >
          CANCEL
        </button>

        <button
          onClick={confirmSave}
          disabled={isSaving || !trackTitle.trim()}
          style={{
            flex: 1,
            padding: "16px",
            fontSize: "14px",
            fontWeight: "bold",
            backgroundColor: (isSaving || !trackTitle.trim()) 
              ? "#1a1a1a"
              : "#0a0a0a",
            color: (isSaving || !trackTitle.trim()) 
              ? "#444"
              : (saveMode === "publish" ? "#ff00ff" : "#00ff88"),
            border: (isSaving || !trackTitle.trim())
              ? "2px solid #333"
              : (saveMode === "publish" ? "2px solid #ff00ff" : "2px solid #00ff88"),
            borderRadius: "8px",
            cursor: (isSaving || !trackTitle.trim()) ? "not-allowed" : "pointer",
            boxShadow: (isSaving || !trackTitle.trim()) 
              ? "none"
              : (saveMode === "publish" 
                ? "0 0 30px rgba(255, 0, 255, 0.5)"
                : "0 0 30px rgba(0, 255, 136, 0.5)"),
            textShadow: (isSaving || !trackTitle.trim())
              ? "none"
              : (saveMode === "publish"
                ? "0 0 10px rgba(255, 0, 255, 0.8)"
                : "0 0 10px rgba(0, 255, 136, 0.8)"),
            fontFamily: "monospace",
            letterSpacing: "1px"
          }}
          onMouseEnter={(e) => {
            if (!isSaving && trackTitle.trim()) {
              e.target.style.backgroundColor = saveMode === "publish" ? "#ff00ff" : "#00ff88";
              e.target.style.color = "#0a0a0a";
              e.target.style.textShadow = "none";
            }
          }}
          onMouseLeave={(e) => {
            if (!isSaving && trackTitle.trim()) {
              e.target.style.backgroundColor = "#0a0a0a";
              e.target.style.color = saveMode === "publish" ? "#ff00ff" : "#00ff88";
              e.target.style.textShadow = saveMode === "publish"
                ? "0 0 10px rgba(255, 0, 255, 0.8)"
                : "0 0 10px rgba(0, 255, 136, 0.8)";
            }
          }}
        >
          {isSaving ? "SAVING..." : (currentTrackId ? "UPDATE" : (saveMode === "publish" ? "PUBLISH" : "SAVE"))}
        </button>
      </div>
    </div>
  </div>
)}
    </div>
  </>
);
}

export default StudioPage;